import ar from './ar.json';
import dk from './dk.json';
import en from './en.json';
import es from './es.json';
import zh from './zh.json';

interface LanguageConfig {
    [key: string]: {
        common: {
            en: string;
            dk: string;
            zh: string;
            ar: string;
            es: string;
            light: string;
            dark: string;
            system: string;
            toggleTheme: string;
            switchAccount: string;
            user: string;
            showAll: string;
            crypto: string;
            cryptoSpot: string;
            cryptoCFD: string;
            fxSpot: string;
            indexCFD: string;
            commCFD: string;
            futuresCFD: string;
            saveChanges: string;
            cancel: string;
            confirm: string;
            update: string;
            from: string;
            to: string;
            switch: string;
            review: string;
            max: string;
            general: string;
            tradeInfo: string;
            symbol: string;
            underlying: string;
            type: string;
            ccy: string;
            ccy1: string;
            ccy2: string;
            description: string;
            subType: string;
            mifidScope: string;
            priceDecimals: string;
            quantityDecimals: string;
            ccy2Enabled: string;
            minOrderSize: string;
            minOrderSizeCcy1: string;
            minOrderSizeCcy2: string;
            latencies: string;
            resetLayout: string;
            loading: string;
            search: string;
            reset: string;
            dateRange: string;
            startDate: string;
            endDate: string;
            requestStatus: string;
            nothingFound: string;
            instrumentInfo: string;
            back: string;
            yes: string;
            no: string;
            enabled: string;
            disabled: string;
            removeFromWatchlist: string;
            addToWatchlist: string;
            historicSearch: string;
            clear: string;
            unknownDate: string;
            toDateIsBeforeFromDate: string;
            remove: string;
            noOptionsFound: string;
            close: string;
            pleaseRefreshYourBrowserToSeeTheNewChanges: string;
            newVersionOfTraderAvailable: string;
            exportAsCSVFile: string;
            exportAsXLSXFile: string;
            withdrawalAccount: string;
            here: string;
            updatingToTheLatest: string;
            copied: string;
            others: string;
            custom: string;
        };
        workspace: {
            workspace: string;
            yourLayouts: string;
            createNewLayout: string;
            addModule: string;
            emptyWorkspace: string;
            addModulesToYourWorkspace: string;
            startWithATemplate: string;
        };
        navigation: {
            settings: string;
            helper: string;
            logout: string;
            overview: string;
            deposits: string;
            withdrawals: string;
            trades: string;
            instruments: string;
            'fx swaps': string;
            'bank accounts': string;
            wallets: string;
            tradingPlatforms: string;
        };
        modules: {
            order: string;
            chart: string;
            blotter: string;
            balances: string;
            markets: string;
            'order-book': string;
            tickers: string;
            'account-value': string;
        };
        login: {
            title: string;
            username: string;
            password: string;
            loginButton: string;
            forgotPassword: string;
            termsOfBusiness: string;
            contactUs: string;
            helpAndResources: string;
            systemStatus: {
                operational: string;
                attempting: string;
                maintenance: string;
                outage: string;
            };
        };
        forgotPassword: {
            title: string;
            username: string;
            resetButton: string;
            backToLogin: string;
            successMessage: string;
            pleaseCheckEmail: string;
            didntReceiveEmail: string;
            resendIn: string;
        };
        resetPassword: {
            title: string;
            backToLogin: string;
            username: string;
            newPassword: string;
            confirmNewPassword: string;
            changePasswordButton: string;
            missingTokenError: string;
            passwordMismatchError: string;
            successMessage: string;
            checkYourEmail: string;
            weSentPasswordResetLink: string;
            didntReceiveEmail: string;
            clickHereToResend: string;
            tokenExpired: string;
            thePasswordResetLinkHasExpired: string;
            requestNewRestLink: string;
            pleaseReachOutToSupport: string;
        };
        twoFactorAuth: {
            title: string;
            enterVerificationCode: string;
            followInstructions: string;
            openAuthenticatorApp: string;
            toCompleteSetup: string;
            googleAuthenticator: string;
            microsoftAuthenticator: string;
            scanTheQRCodeOrManually: string;
            enterTheSixDigitCode: string;
        };
        orderForm: {
            buy: string;
            sell: string;
            orderType: string;
            stopType: string;
            limitOrder: string;
            marketOrder: string;
            stopOrder: string;
            ocoOrder: string;
            price: string;
            limitPrice: string;
            stopPrice: string;
            stopLimitPrice: string;
            quantity: string;
            vwap: string;
            currentBest: string;
            bid: string;
            ask: string;
            spread: string;
            approx: string;
            total: string;
            slippage: string;
            duration: string;
            timeInForce: string;
            IOC: string;
            FOK: string;
            GTC: string;
            placeOrder: string;
            insufficientBalance: string;
            minOrderSize: string;
            orderSubmitted: string;
            orderFailed: string;
            pleaseEnsureAllInputsAreValid: string;
            clickOnceToEnableButton: string;
            clickToPlaceOrder: string;
            noSettlementDateAvailable: string;
            noHistoryWasFoundForThisOrder: string;
            currentOrder: string;
            linkedOrder: string;
            orderHistory: string;
            openInSeparateWindow: string;
            downloadToCSV: string;
            orderCancellation: string;
            areYouSureYouWantToCancelBothOrders: string;
            areYouSureYouWantToCancelThisOrder: string;
            cancelBothOrders: string;
            cancelOrder: string;
            symbolName: string;
            closePosition: string;
            closeOrderWasNotSubmitted: string;
            thePositionChangedBeforeExecution: string;
            currentNetPosition: string;
            resetToNewPosition: string;
            estimatedFees: string;
            estimatingFees: string;
            estimatedBalances: string;
            estimatedProceeds: string;
            feesApplied: string;
        };
        orderBook: {
            vertical: string;
            horizontal: string;
            sizeAcc: string;
            size: string;
            price: string;
            tobSpread: string;
            spread: string;
            ask: string;
            bid: string;
            askSize: string;
            bidSize: string;
            noData: string;
        };
        blotters: {
            orders: string;
            trades: string;
            openPositions: string;
            showAll: string;
            filled: string;
            open: string;
            cancelled: string;
            orderId: string;
            status: string;
            instrument: string;
            orderType: string;
            side: string;
            ccy: string;
            qty: string;
            price: string;
            slippage: string;
            lastPrice: string;
            lastQty: string;
            avgPrice: string;
            stopPrice: string;
            cumQty: string;
            leavesQty: string;
            rejected: string;
            ordState: string;
            ordQty: string;
            filledQty: string;
            openQty: string;
            cxlQty: string;
            pctFilled: string;
            created: string;
            updated: string;
            account: string;
            user: string;
            executionType: string;
            tif: string;
            executionTime: string;
            type: string;
            fillPrice: string;
            avgFillPrice: string;
            ccy1: string;
            qty1: string;
            ccy2: string;
            qty2: string;
            executionId: string;
            fillNo: string;
            netQtyPosition: string;
            close: string;
            openPrice: string;
            currentPrice: string;
            unrealisedPnl: string;
            realisedPnl: string;
            valueDate: string;
            settlementDate: string;
            accountCode: string;
            amount: string;
            unrealisedPnlInBaseCurrency: string;
            date: string;
            method: string;
            noTableRecords: string;
            currentTradeDate: string;
            filters: string;
            searchResults: string;
            generalSearch: string;
            downloadData: string;
            instrumentType: string;
            refreshResults: string;
            rowsReturned: string;
            outOfAMaximum: string;
            fillInAboveCriteria: string;
            noOrdersFound: string;
            tradeId: string;
            tradeDate: string;
            subType: string;
            symbol: string;
            contraAmount: string;
            tradeLinkId: string;
            uti: string;
            expiryDate: string;
            optionStyle: string;
            optionType: string;
            optionVariant: string;
            fees: string;
            feesCcy: string;
            strikePrice: string;
            lowerBarrier: string;
            upperBarrier: string;
            fixApiSymbol: string;
            quantityDecimals: string;
            quantity1Decimals: string;
            quantity2Decimals: string;
            pipsDecimals: string;
            swapDecimals: string;
            valueDateConvention: string;
            cfi: string;
            upi: string;
            mifidScope: string;
            positionUtiPattern: string;
            tradeUtiPattern: string;
            ccy1Network: string;
            ccy1NetworkType: string;
            bankAccount: string;
            wallet: string;
            show: string;
            pair: string;
            time: string;
            viewOrderHistory: string;
            amendOrder: string;
            page: string;
            groupBy: string;
        };
        balances: {
            settlementDate: string;
            currency: string;
            balance: string;
            total: string;
            unableToFetch: string;
            pleaseReachOut: string;
        };
        accountValue: {
            marginUsed: string;
            availableMargin: string;
            marginUsage: string;
            unrealizedPL: string;
            equity: string;
            cashBalance: string;
        };
        tickers: {
            collapse: string;
            expand: string;
            tools: string;
            watchlist: string;
            newWatchlist: string;
            editWatchlist: string;
            deleteWatchlist: string;
            actions: string;
            instrumentSelector: string;
            createWatchlist: string;
            startAddingTickers: string;
            areYouSureDeleteWatchlist: string;
            deletingWatchlistWillRemoveInstruments: string;
            thisActionCannotBeUndone: string;
            inputWatchlistName: string;
            editWatchlistName: string;
            order: string;
            noOrderBookData: string;
            noPrice: string;
            startAddingTickersWithTheInstrumentSelector: string;
        };
        lite: {
            convert: string;
            deposit: string;
            withdraw: string;
            yourBalances: string;
            asset: string;
            cryptoAssets: string;
            currency: string;
            fiatCurrencies: string;
            settlements: string;
            todaysMarket: string;
            marketMonitorSettings: string;
            arrangeTheCurrencies: string;
            icon: string;
            removeMarkets: string;
            finishedEditing: string;
            clickToAddMarkets: string;
            youMayArrange: string;
            addMarketMonitor: string;
            editMarketMonitor: string;
            pleaseSelectBaseCurrencyToMonitor: string;
            pleaseSelectBaseCurrency: string;
            pleaseSelectQuoteCurrency: string;
            nowSelectCurrencyAgainstBase: string;
            resetBaseCurrency: string;
            estimatedProceed: string;
            conversionRate: string;
            youHave: string;
            estimatedBalancesAfterConversion: string;
            confirmOrder: string;
            noPricesAvailable: string;
        };
        portal: {
            accountOverview: string;
            generateStatement: string;
            generateAccountStatement: string;
            selectTheDateRangeToBeIncluded: string;
            dateRange: string;
            startDate: string;
            endDate: string;
            format: string;
            pleaseNoteThatTheGeneratedStatement: string;
            current: string;
            history: string;
            assetClassAllocation: string;
            instrumentExposure: string;
            currencyExposure: string;
            historicBalances: string;
            historicOptionPositions: string;
            historicOpenPositions: string;
            currentBalances: string;
            currentOptionPositions: string;
            currentOpenPositions: string;
            makeADeposit: string;
            bankTransfer: string;
            bankTransferDescription: string;
            cryptoTransfer: string;
            cryptoTransferDescription: string;
            standardSettlementInstructions: string;
            standardSettlementInstructionsDescription: string;
            depositHistory: string;
            requestAWithdrawal: string;
            bankAccountWithdrawal: string;
            bankAccountWithdrawalDescription: string;
            cryptoWallet: string;
            cryptoWalletDescription: string;
            internalTransfer: string;
            internalTransferDescription: string;
            withdrawalHistory: string;
            recentTrades: string;
            accountInstuments: string;
            addBankAccount: string;
            addWalletAddress: string;
            whitelistedBankAccounts: string;
            whitelistedWalletAddresses: string;
            recentRequestedTransactions: string;
            historicDate: string;
            backTo: string;
            account: string;
            actions: string;
            weight: string;
            noBankAccountsWhitelistedYet: string;
            noWalletAddressesWhitelistedYet: string;
            depositViaBankTransfer: string;
            depositViaCryptoTransfer: string;
            requestDetails: string;
            supportDetails: string;
            supportDetailsFile: string;
            depositInformation: string;
            amountToDeposit: string;
            bankDetails: string;
            walletDetails: string;
            requestDescription: string;
            supportingInformation: string;
            supportingInformationOptional: string;
            transactionHash: string;
            dragOrClickToUpload: string;
            supportFileFormatsAre: string;
            attachedFileShouldNotExceed: string;
            nextStep: string;
            previousStep: string;
            submitRequest: string;
            fiatViaBankTransfer: string;
            cryptoViaWalletAddress: string;
            makeADepositFromYourWhitelistedBankAccount: string;
            makeADepositToYourWhitelistedWalletAddress: string;
            depositFunds: string;
            depositFiatDescription: string;
            depositCryptoDescription: string;
            transferFundsFromYourWhitelistedBankAccount: string;
            selectedBankAccountToViewDetails: string;
            token: string;
            network: string;
            chain: string;
            address: string;
            beneficiaryName: string;
            beneficiaryAddress: string;
            bankName: string;
            bankAddress: string;
            country: string;
            branchName: string;
            accountNumber: string;
            ibanCode: string;
            swiftCode: string;
            notes: string;
            walletAddress: string;
            correspondentInformation: string;
            correspondentBankDetails: string;
            correspondentBankName: string;
            correspondentSwiftCode: string;
            intermediaryInformation: string;
            intermediaryBankDetails: string;
            intermediaryBankName: string;
            intermediarySwiftCode: string;
            noBankAccountInformationAvailable: string;
            noSupportedAssets: string;
            withdrawalViaBankTransfer: string;
            withdrawalViaCryptoTransfer: string;
            availableBalance: string;
            noAvailableBalance: string;
            selectAWithdrawalCurrency: string;
            selectAWithdrawalAsset: string;
            amountToWithdraw: string;
            makeAnInternalTransfer: string;
            transferType: string;
            amountToTransfer: string;
            fromAccount: string;
            toAccount: string;
            additionalInformation: string;
            proofOfOwnership: string;
            proofOfOwnershipOptional: string;
            generalInformation: string;
            friendlyName: string;
            bankAccountInformation: string;
            walletInformation: string;
            swiftBIC: string;
            swiftBICABARoutingNumber: string;
            abaRoutingNumber: string;
            sortCode: string;
            bsbNumber: string;
            registrationNumber: string;
            additionalAccountNumber: string;
            walletType: string;
            networkInformation: string;
            tagMemo: string;
            termsAndConditions: string;
            vaspInformation: string;
            vasp: string;
            vaspLEN: string;
            vaspCountry: string;
            vaspLEI: string;
            vaspEmail: string;
            vaspAddress: string;
            assets: string;
            remark: string;
            bankAccountDetails: string;
            walletAddressDetails: string;
            invalidWalletAddressFormat: string;
            theFollowingWalletAddressRequested: string;
            doYouStillWishToSubmit: string;
            cancelBankAccountRequest: string;
            dismissBankAccountRequest: string;
            deactivateBankAccount: string;
            cancelWalletAddressRequest: string;
            dismissWalletAddressRequest: string;
            deactivateWalletAddress: string;
            areYouSureYouWantTo: string;
            cancelTheRequestFor: string;
            deactivate: string;
            theVideoIsNotSupported: string;
            pleaseDownloadTheVideoToViewIt: string;
            butItIsReadyToBeUploaded: string;
            downloadVideo: string;
            whitelistBankAccountError: string;
            whitelistWalletAddressError: string;
            pleaseTransferFundsONLYFromWhitelistedBankAccounts: string;
            pleaseTransferFundsONLYFromWhitelistedWalletAddresses: string;
            pleaseContactSupportToSetUpYourDepositRequest: string;
            tappingOnTheWalletAddressWillCopyItToYourClipboard: string;
            clickingOnTheWalletAddressWillCopyItToYourClipboard: string;
            tradeDate: string;
            instrumentName: string;
            bidRate: string;
            askRate: string;
            statementQueuedForGeneration: string;
            processingStatementData: string;
            generatingComplete: string;
            generatingStatement: string;
            takingLongerThanExpected: string;
            remainPatient: string;
            contraCurrency: string;
            contraCurrencyTooltip: string;
            transfer: string;
        };
        settings: {
            generalTab: string;
            tradingTab: string;
            notificationsTab: string;
            userTab: string;
            timezoneSettings: string;
            timezoneSettingsDescription: string;
            themeSettings: string;
            languageSettings: string;
            tradingLayoutSettings: string;
            tradingLayoutSettingsDescription: string;
            twoClickTradingSettings: string;
            twoClickTradingSettingsDescription: string;
            shortSellPreventionSettings: string;
            shortSellPreventionSettingsDescription: string;
            defaultMarketOrderDurationSettings: string;
            defaultMarketOrderDurationSettingsDescription: string;
            defaultLimitOrderDurationSettings: string;
            defaultLimitOrderDurationSettingsDescription: string;
            defaultStopOrderDurationSettings: string;
            defaultStopOrderDurationSettingsDescription: string;
            showNotificationsSettings: string;
            showMillisecondsSettings: string;
            idleTimeoutSettings: string;
            idleTimeoutSettingsDescription: string;
            changePassword: string;
            resetCurrentPassword: string;
        };
        helper: {
            title: string;
            subtitle: string;
            inputPlaceholder: string;
            askButton: string;
            suggestionsTitle: string;
            exampleWorkspace: string;
            exampleOrderBook: string;
            exampleSettings: string;
            exampleTour: string;
            foundFeatures: string;
            noMatchesTitle: string;
            noMatchesBody: string;
            highlightFeature: string;
            startTour: string;
            clearHighlight: string;
            highlightedPrefix: string;
            featureNotVisible: string;
            workspaceDescription: string;
            addModuleDescription: string;
            settingsDescription: string;
            notificationsDescription: string;
            tourDescription: string;
            orderFormDescription: string;
            balancesDescription: string;
            tickersDescription: string;
            chartDescription: string;
            orderBookDescription: string;
            blotterDescription: string;
            marketsDescription: string;
            accountValueDescription: string;
            workspaceKeywords: string[];
            addModuleKeywords: string[];
            settingsKeywords: string[];
            accountNavigationKeywords: string[];
            notificationsKeywords: string[];
            startTourKeywords: string[];
            orderKeywords: string[];
            balancesKeywords: string[];
            tickersKeywords: string[];
            chartKeywords: string[];
            orderBookKeywords: string[];
            blotterKeywords: string[];
            marketsKeywords: string[];
            accountValueKeywords: string[];
        };
        notifications: {
            all: string;
            unseen: string;
            seen: string;
            popUpsDisabledUntilNextLogin: string;
            markAllAsSeen: string;
            showMore: string;
            showingAllNotifications: string;
            noNotifications: string;
            dismiss: string;
            hideNotificationPopUpsUntilNextLogin: string;
            notificationsAreStillAvailable: string;
        };
        onboarding: {
            welcome: {
                title: string;
                descriptionSpot: string;
                descriptionTrader: string;
            };
            workspaceOverview: {
                title: string;
            };
            accountOverview: {
                title: string;
                description: string;
            };
            deposit: {
                title: string;
            };
            withdrawal: {
                title: string;
            };
            bankWallet: {
                titleSpot: string;
                titleTrader: string;
                descriptionSpot: string;
                descriptionTrader: string;
            };
            settings: {
                title: string;
                description: string;
            };
            notifications: {
                title: string;
            };
            helpSupport: {
                title: string;
            };
            balances: {
                title: string;
            };
            orderForm: {
                title: string;
            };
            tickers: {
                title: string;
            };
            security: {
                title: string;
            };
            chart: {
                title: string;
            };
            orderBook: {
                title: string;
            };
            blotter: {
                title: string;
            };
            markets: {
                title: string;
            };
            otherFunctions: {
                title: string;
            };
            accountValue: {
                title: string;
            };
        };
        onboardingStepContent: {
            tickers: {
                generalTab: string;
                tipsTab: string;
                settingsTab: string;
                generalSteps: string[];
                tipsSteps: string[];
                settingsSteps: string;
            };
            blotter: {
                intro: string;
                highlights: string[];
            };
            accountValue: {
                intro: string;
                footer: string;
            };
            balances: {
                intro: string;
                highlights: string[];
            };
            markets: {
                intro: string;
                highlights: string[];
            };
            orderForm: {
                generalTab: string;
                tipsTab: string;
                settingsTab: string;
                generalSteps: string[];
                tipsSteps: string[];
                settingsSteps: string;
            };
            chart: {
                introSpot: string;
                introTrader: string;
                highlights: string[];
            };
            orderBook: {
                highlights: string[];
            };
            security: {
                highlights: string[];
                note: string;
            };
            otherFunctions: {
                intro: string;
                highlights: string[];
            };
            notifications: {
                intro: string;
            };
            workspaceOverview: {
                intro: string;
                highlights: string[];
                footer: string;
            };
        };
        onboardingUi: {
            previous: string;
            next: string;
            skipTour: string;
            finishTour: string;
            previousStepAria: string;
            nextStepAria: string;
            completeTourAria: string;
        };
        onboardingSteps: {
            stepWelcome: {
                introSpot: string;
                introTrader: string;
                highlights: string[];
                footer: string;
                note: string;
            };
            stepDeposit: {
                depositsTab: string;
                depositsIntroSpot: string;
                depositsIntroTrader: string;
                depositFlowSpot: string[];
                depositFlowTrader: string[];
            };
            stepWithdrawal: {
                withdrawalsTab: string;
                withdrawalsIntroSpot: string;
                withdrawalsIntroTrader: string;
                withdrawalFlowSpot: string[];
                withdrawalFlowTrader: string[];
            };
            stepBankWallet: {
                bankAccountsTab: string;
                walletsTab: string;
                bankIntro: string;
                bankSteps: string[];
                walletIntro: string;
                walletItems: string[];
                walletNote: string;
            };
            stepHelpSupport: {
                completionBody: string;
            };
        };
    };
}

export default {
    en,
    dk,
    zh,
    ar,
    es
} as LanguageConfig;
